module.exports = __webpack_public_path__ + "static/img/8.3b0260a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/zh/8.png
// module id = cz7m
// module chunks = 0